// GET
export const GET_TEMPLATES = "GET_TEMPLATES"
export const GET_TEMPLATES_SUCCESS = "GET_TEMPLATES_SUCCESS"

export const GET_TEMPLATES_BY_ID = "GET_TEMPLATES_BY_ID"
export const GET_TEMPLATES_BY_ID_SUCCESS = "GET_TEMPLATES_BY_ID_SUCCESS"

export const GET_TEMPLATES_BY_ID_CONTROL = "GET_TEMPLATES_BY_ID_CONTROL"
export const GET_TEMPLATES_BY_ID_CONTROL_SUCCESS = "GET_TEMPLATES_BY_ID_CONTROL_SUCCESS"

export const GET_TEMPLATES_BY_TYPE = "GET_TEMPLATES_BY_TYPE"
export const GET_TEMPLATES_BY_TYPE_SUCCESS = "GET_TEMPLATES_BY_TYPE_SUCCESS"

export const GET_TEMPLATES_STUDIO_BY_TYPE = "GET_TEMPLATES_STUDIO_BY_TYPE"
export const GET_TEMPLATES_STUDIO_BY_TYPE_SUCCESS = "GET_TEMPLATES_STUDIO_BY_TYPE_SUCCESS"
// POST
export const POST_PUBLISH_TEMPLATES = "POST_PUBLISH_TEMPLATES"
export const POST_DRAFT_TEMPLATES = "POST_DRAFT_TEMPLATES"
export const DUPLICATE_TEMPLATES = "DUPLICATE_TEMPLATES"
export const DUPLICATE_TEMPLATES_GOVERNANCE = "DUPLICATE_TEMPLATES_GOVERNANCE"
// PATCH
export const PATCH_PUBLISHED_TEMPLATE = "PATCH_PUBLISHED_TEMPLATE"
export const PATCH_TEMPLATES_BY_ID = "PATCH_TEMPLATES_BY_ID"
export const PATCH_LABEL_QUESTION_BY_ID = "PATCH_LABEL_QUESTION_BY_ID"
// DELETE
export const DELETE_TEMPLATES_BY_ID = "DELETE_TEMPLATES_BY_ID"
export const DELETE_TEMPLATES_GOVERNANCE_BY_ID = "DELETE_TEMPLATES_GOVERNANCE_BY_ID"
// LOADER
export const SET_LOADER_DATA = "SET_LOADER_DATA"
